import helper from '../helper'

export default {
  controller: '/persons',
  all (callback) {
    helper.getRequest(this.controller, false, callback)
  },
  delete (id, callback) {
    helper.deleteRequest(this.controller + '/' + id, true, callback)
  },
  update (person, img, callback) {
    let data = new FormData()
    data.append('id', person.id)
    data.append('name', person.name)
    data.append('title', person.title)
    data.append('color', person.color)
    data.append('img', img)
    data.append('_method', 'PUT')
    helper.postRequest(this.controller + '/' + person.id, true, data, callback)
  },
  add (person, img, callback) {
    let data = new FormData()
    data.append('id', person.id)
    data.append('name', person.name)
    data.append('title', person.title)
    data.append('color', person.color)
    data.append('img', img)
    helper.postRequest(this.controller, true, data, callback)
  }
}



// WEBPACK FOOTER //
// ./src/services/rest/controllers/persons.js